<script setup lang="ts">

</script>

<template>
  <h1>Certifications</h1>
</template>

<style scoped>

</style>